import { UseFormReturnType } from "@mantine/form";
import { FormValues } from "../../types";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { getLocalizedName, getLocalizedValue } from "@/utils";
import { getTranslatedTimeframe } from "@/utils";
import { Button } from "@heroui/react";
import { LimeSwitch } from "@/Components/NextBase/LimeSwitch";

const ConfirmationTab = ({
  form,
  hasChangedVariations,
}: {
  form: UseFormReturnType<FormValues>;
  hasChangedVariations: boolean;
}) => {
  console.log("form", form.values);

  const isNew = !form.values.id;
  return (
    <>
      <div className="border-black-200 rounded-lg border-1 p-4">
        <h3 className="text-lg font-medium">
          {getLocalizedValue(form.values.nameLocalized)}
        </h3>
        <p className="text-xs">
          <span className="font-normal">
            <Trans>Število variacij</Trans>:
          </span>{" "}
          <span className="font-semibold">
            {form.values.subscriptionVariations.length}
          </span>
        </p>
        <div className="flex items-start justify-start gap-1 text-xs">
          <span className="font-normal">
            <Trans>Storitve</Trans>:
          </span>{" "}
          <div className="font-semibold">
            {form.values.subscriptionServices.length}
            <ul className="">
              {form.values.subscriptionServices.map((subscriptionService) => (
                <li
                  key={getLocalizedName(
                    subscriptionService.service.nameLocalized,
                  )}
                >
                  {getLocalizedName(subscriptionService.service.nameLocalized)}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {form.values.subscriptionVariations.map((variation) => (
          <div
            className="mt-4 rounded-lg border-1 border-gray-300 p-4"
            key={variation.id || JSON.stringify(variation.nameLocalized)}
          >
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-medium">
                {getLocalizedValue(variation.nameLocalized)}
              </h3>
              <p>
                <span className="font-normal">
                  <Trans>Cena</Trans>:
                </span>{" "}
                <span className="font-semibold">{variation.priceCents}</span>
              </p>
            </div>
            <p className="text-xs">
              <span className="font-normal">
                <Trans>Trajanje</Trans>:
              </span>{" "}
              <span className="font-semibold">
                {variation.durationValue}{" "}
                {getTranslatedTimeframe(variation.durationUnit)}
              </span>
            </p>
            <div className="flex items-start justify-start gap-1">
              <p className="text-xs font-medium">
                <Trans>Omejitve</Trans>:
              </p>
              <ul>
                {variation.limitations.map((limitation) => (
                  <li
                    className="text-xs font-semibold"
                    key={limitation.timeframe}
                  >
                    {limitation.limitAmount} <Trans>obiskov</Trans> /{" "}
                    {getTranslatedTimeframe(limitation.timeframe)}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex items-center justify-end gap-2">
              <Button
                variant="bordered"
                size="sm"
                className="h-6 px-0"
                onPress={() => {
                  form.setFieldValue("currentTab", "variations");
                }}
              >
                <Trans>Uredi</Trans>
              </Button>
              <Button
                variant="bordered"
                size="sm"
                className="h-6 px-0"
                onPress={() => {
                  form.setFieldValue(
                    "subscriptionVariations",
                    form.values.subscriptionVariations.filter(
                      (v) => JSON.stringify(v) !== JSON.stringify(variation),
                    ),
                  );
                }}
              >
                <Trans>Izbriši</Trans>
              </Button>
            </div>
          </div>
        ))}
      </div>

      {hasChangedVariations && !isNew && (
        <div className="my-4 flex items-center gap-2">
          <LimeSwitch
            title={t`Posodobi tudi obstoječe naročnine strank, ki uporabljajo spremenjene variacije`}
            {...form.getInputProps("updateCustomerSubscriptions", {
              type: "checkbox",
            })}
            size="sm"
          />
        </div>
      )}
    </>
  );
};

export default ConfirmationTab;
